import '../../style/index.less';
import './index.less';

// style dependencies
import '../../select/style';
import '../../input/style';



// WEBPACK FOOTER //
// ./_antd1.11.2/pagination/style/index.js